import React, { Component } from 'react';
import { Modal, Input, Button } from 'antd';
import { inject, observer } from "mobx-react";
import "./index.scss";

const { TextArea } = Input;

@inject('store')
@observer
class index extends Component {
    render() {
        const { visible, onOk, onCancel, data, onChange, loading } = this.props.store.applybilling;
        return (
            <Modal
                maskClosable={false}
                title="申请开票"
                visible={visible}
                onCancel={onCancel}
                cancelText="取消"
                okText="提交"
                className="apply-billing"
                footer={[
                    <Button key="back" onClick={onCancel}>
                        取消
                    </Button>,
                    <Button
                        type="primary"
                        loading={loading}
                        onClick={() => onOk(this.props.getData)}
                    >
                        提交
                    </Button>,
                ]}
            >
                <p className="order-no">订单编号：{data.out_trade_no}</p>
                <p >请填写发票接收信息</p>
                <p>
                    <span className="billing-name">发票抬头:</span>
                    <Input
                        placeholder="请输入发票抬头"
                        value={data.billing_invoice}
                        onChange={e => onChange('billing_invoice', e.target.value)}
                    />
                </p>
                <p>
                    <span className="billing-name">纳税人识别号:</span>
                    <Input
                        placeholder="请输入纳税人识别号"
                        value={data.billing_bank_account}
                        onChange={e => onChange('billing_bank_account', e.target.value)}
                    />
                </p>
                <p>
                    <span className="billing-name">开户行:</span>
                    <Input
                        placeholder="请输入开户行"
                        value={data.billing_bank}
                        onChange={e => onChange('billing_bank', e.target.value)}
                    />
                </p>
                <p>
                    <span className="billing-name">开户账号:</span>
                    <Input
                        placeholder="请输入开户账号"
                        value={data.billing_number}
                        onChange={e => onChange('billing_number', e.target.value)}
                    />
                </p>
                <p>
                    <span className="billing-name">公司电话:</span>
                    <Input
                        placeholder="请输入公司电话"
                        value={data.company_phone}
                        onChange={e => onChange('company_phone', e.target.value)}
                    />
                </p>
                <p>
                    <span className="billing-name">开票地址:</span>
                    <TextArea
                        placeholder="请输入接收地址"
                        rows={2}
                        value={data.company_addr}
                        onChange={e => onChange('company_addr', e.target.value)}
                    />
                </p>
                <p>
                    <span className="billing-name">邮箱:</span>
                    <Input
                        placeholder="请输入发票接收邮箱"
                        value={data.email}
                        onChange={e => onChange('email', e.target.value)}
                    />
                </p>

            </Modal>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/user/ApplyBilling/index.js